export var ENTITY = "preference";
export var REDUCER_KEY = "PREFERENCE_V2";
export var BASE_PATH_ENTITY = "preference";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
